import { useEffect, useState } from "react";
import {useSelector} from "react-redux"
import EditAbsenceModal from "views/app-views/absences/components/edit-absence";
import NewAbsenceModal from "views/app-views/absences/components/new-absence";
// import EditCalendarModal from "views/app-views/calendars/components/edit-calendar";
import NewCalendar from "views/app-views/calendars/components/new-calendar";
import EditCategoryModal from "views/app-views/categories/components/edit-category";
import NewCategoryModal from "views/app-views/categories/components/new-category";
import EditCourseStateModal from "views/app-views/courses/components/edit-state-modal";
import NewEmailModal from "views/app-views/emails/components/new-email";
import EditEventModal from "views/app-views/events/components/edit-event-modal";
import NewEventModal from "views/app-views/events/components/new-event-modal";
import EditExpenseModal from "views/app-views/expenses/components/edit-expense";
import NewExpenseModal from "views/app-views/expenses/components/new-expense";
import AddFormerToGroupModal from "views/app-views/groups/components/add-former-to-groupe-modal";
import NewSupportCourseGroupModal from "views/app-views/groups/components/new-support-course-group-modal";
import NewTrainingGroupModal from "views/app-views/groups/components/new-training-group-modal";
import UpdateStudentSupportCourseGroupModal from "views/app-views/groups/components/update-student-support-course-group-modal";
import UpdateStudentTrainingGroupModal from "views/app-views/groups/components/update-student-training-group-modal";
import DeleteInstructorModal from "views/app-views/instructors/components/delete-instructor-modal";
import AssignToInstructorModal from "views/app-views/instructors/components/assign-to-instructor-modal";
import EditInstructorModal from "views/app-views/instructors/components/edit-instructor";
import NewInstructorModal from "views/app-views/instructors/components/new-instructor";
import EditInternshipModal from "views/app-views/internships/components/edit-internship";
import NewInternshipModal from "views/app-views/internships/components/new-internship";
import AddStudentToInternshipModal from "views/app-views/internships/internship-details/components/add-student-modal";
import CreateEditLiveStreamModal from "views/app-views/live-streams/components/create-edit-live-stream-modal";
import EditRoomModal from "views/app-views/rooms/components/edit-room";
import NewRoomModal from "views/app-views/rooms/components/new-room";
import PaymentModal from "views/app-views/salaries/components/payment-modal";
import NewSchoolModal from "views/app-views/schools/components/new-school";
import PayModal from "views/app-views/students/components/edit-payment";
import EditStudentModal from "views/app-views/students/components/edit-student";
import NewStudentModal from "views/app-views/students/components/new-student";
import EditSubjectModal from "views/app-views/subjects/components/edit-subject-modal";
import NewSubjectModal from "views/app-views/subjects/components/new-subject-modal";
import AddStudentToSupportCourseModal from "views/app-views/support-courses/components/add-students-to-support-course-modal";
import EditSupportCourseModal from "views/app-views/support-courses/components/edit-support-course-modal";
import NewSupportCourseModal from "views/app-views/support-courses/components/new-support-course-modal";
import AssignInstructorToTrainingModal from "views/app-views/trainings/components/assign-instructor-to-training-modal";
import AddStudentsToTrainingModal from "views/app-views/trainings/components/add-students-to-training";
import EditTutorialStatusModal from "views/app-views/tutorials/components/edit-status-modal";
import EditTutorialVisibilityModal from "views/app-views/tutorials/components/edit-visibility-modal";
import AddSessionModal from "views/app-views/support-courses/components/add-session";
import EditCalendar from "views/app-views/calendars/components/edit-calendar";
import AssignSupportCourseInstructorModal from "views/app-views/support-courses/components/assign-support-course-instructor-modal";
import NewPromotionModal from "views/app-views/promotions/components/new-promotion";
import EditPromotionModal from "views/app-views/promotions/components/edit-promotion";
import DeletePromotionModal from "views/app-views/promotions/components/delete-promotion";
import EditGroupNameModal from "views/app-views/groups/components/EditGroupNameModal";
import AddGroupExerciseModal from "views/app-views/groups/components/add-group-exercise-modal";
import CertificatePreviewModal from "views/app-views/certificates/components/certificate-preview-modal";
const ModalsProvider = () => {
  const [mounted, setMounted] = useState(false);
  const { modalType, modalProps } = useSelector((state) => state.modals);
  useEffect(() => {
    if (!mounted) setMounted(true);
  }, [mounted]);

  
  // Rendu conditionnel des modaux en fonction du type
  const renderModal = () => {
    if (modalType === "new_calendar") {
      return <NewCalendar modalProps={modalProps} />;
    }

    // Tu pourrais refactoriser les autres modaux de la même façon
    return null;
  };
  
  if (!mounted) {
    return null;
  }

  return (
    <>
      {renderModal()}
      <NewPromotionModal />
      <EditPromotionModal />
      <DeletePromotionModal />
      <CreateEditLiveStreamModal />
      <NewInstructorModal />
      <EditInstructorModal />
      <DeleteInstructorModal />
      <AssignToInstructorModal />
      <NewSchoolModal />
      <NewRoomModal />
      <NewEmailModal />
      <EditRoomModal />
      <NewCategoryModal />
      <EditCategoryModal />
      <NewExpenseModal />
      <EditExpenseModal />
      <NewInternshipModal />
      <EditInternshipModal />
      <NewStudentModal />
      <EditStudentModal />
      <AddStudentToInternshipModal />
      {/* <EditCalendarModal /> */}
      <PaymentModal />
      <NewAbsenceModal />
      <EditAbsenceModal />
      <AddStudentsToTrainingModal />
      <PayModal />
      <NewEventModal />
      <EditEventModal />
      <EditTutorialVisibilityModal />
      <EditTutorialStatusModal />
      <EditCourseStateModal />
      <NewTrainingGroupModal />
      <UpdateStudentTrainingGroupModal />
      <UpdateStudentSupportCourseGroupModal />
      <AddFormerToGroupModal />
      <EditGroupNameModal />
      <AddGroupExerciseModal />
      <NewSupportCourseModal />
      <EditSupportCourseModal />
      <NewSubjectModal />
      <EditSubjectModal />
      <AddStudentToSupportCourseModal />
      <NewSupportCourseGroupModal />
      <AddSessionModal />
      <EditCalendar />
      <AssignSupportCourseInstructorModal />
      <AssignInstructorToTrainingModal />
      <CertificatePreviewModal />
    </>
  );
};

export default ModalsProvider;
